import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconEventStart$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconEventStart extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '8d3d439bc409454ea9dc68eb4e15d049e056476d', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'b86ab2cfe2371dcbded6bea885f5d1f16812b566', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'dabb458437a58d1d50b66fe3c8ff57b2ab4bb991', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M17.494 12.1a6.504 6.504 0 0 1-6.487 6 6.503 6.503 0 0 1-6.506-6.5c0-3.59 2.913-6.5 6.506-6.5h2.316l-.004 2.284a.4.4 0 0 0 .69.29l3.003-3a.4.4 0 0 0 0-.56l-3.002-3a.4.4 0 0 0-.68.29L13.324 3.6h-2.318C6.585 3.6 3 7.182 3 11.6s3.585 8 8.007 8A8.005 8.005 0 0 0 19 12.1a.477.477 0 0 0-.485-.5h-.5a.53.53 0 0 0-.52.5M11.25 8.992v2.556l1.59 1.789a.495.495 0 0 1 0 .698l-.38.325a.506.506 0 0 1-.7 0l-1.88-2.095a.45.45 0 0 1-.13-.324v-2.95c0-.27.224-.491.5-.491h.5c.276 0 .5.22.5.492", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-event-start", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-event-start"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-event-start":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconEventStart$1);
            }
            break;
    } });
}

const CosmosIconEventStart = CosmosIconEventStart$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconEventStart, defineCustomElement };
